
// @ts-nocheck


export const localeCodes =  [
  "af",
  "ar",
  "bg",
  "ca",
  "cs",
  "da",
  "de",
  "dum",
  "el",
  "en",
  "es",
  "fi",
  "fr",
  "he",
  "hu",
  "it",
  "ja",
  "ko",
  "ku",
  "nl",
  "no",
  "pl",
  "pt",
  "ro",
  "ru",
  "srcyrl",
  "sv",
  "tr",
  "uk",
  "zhS",
  "zhT"
]

export const localeLoaders = {
  af: [
    {
      key: "locale_af_46json_2198a108",
      load: () => import("#nuxt-i18n/2198a108" /* webpackChunkName: "locale_af_46json_2198a108" */),
      cache: true
    }
  ],
  ar: [
    {
      key: "locale_ar_46json_183823e4",
      load: () => import("#nuxt-i18n/183823e4" /* webpackChunkName: "locale_ar_46json_183823e4" */),
      cache: true
    }
  ],
  bg: [
    {
      key: "locale_bg_46json_86dd940a",
      load: () => import("#nuxt-i18n/86dd940a" /* webpackChunkName: "locale_bg_46json_86dd940a" */),
      cache: true
    }
  ],
  ca: [
    {
      key: "locale_ca_46json_771a632e",
      load: () => import("#nuxt-i18n/771a632e" /* webpackChunkName: "locale_ca_46json_771a632e" */),
      cache: true
    }
  ],
  cs: [
    {
      key: "locale_cs_46json_0943bc97",
      load: () => import("#nuxt-i18n/0943bc97" /* webpackChunkName: "locale_cs_46json_0943bc97" */),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_e6b058fa",
      load: () => import("#nuxt-i18n/e6b058fa" /* webpackChunkName: "locale_da_46json_e6b058fa" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_cb8195a5",
      load: () => import("#nuxt-i18n/cb8195a5" /* webpackChunkName: "locale_de_46json_cb8195a5" */),
      cache: true
    }
  ],
  dum: [
    {
      key: "locale_dum_46json_0fb323b3",
      load: () => import("#nuxt-i18n/0fb323b3" /* webpackChunkName: "locale_dum_46json_0fb323b3" */),
      cache: true
    }
  ],
  el: [
    {
      key: "locale_el_46json_d5cba8f4",
      load: () => import("#nuxt-i18n/d5cba8f4" /* webpackChunkName: "locale_el_46json_d5cba8f4" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_6f358344",
      load: () => import("#nuxt-i18n/6f358344" /* webpackChunkName: "locale_en_46json_6f358344" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_382738fc",
      load: () => import("#nuxt-i18n/382738fc" /* webpackChunkName: "locale_es_46json_382738fc" */),
      cache: true
    }
  ],
  fi: [
    {
      key: "locale_fi_46json_bdbfd864",
      load: () => import("#nuxt-i18n/bdbfd864" /* webpackChunkName: "locale_fi_46json_bdbfd864" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_44928bea",
      load: () => import("#nuxt-i18n/44928bea" /* webpackChunkName: "locale_fr_46json_44928bea" */),
      cache: true
    }
  ],
  he: [
    {
      key: "locale_he_46json_ab7761e1",
      load: () => import("#nuxt-i18n/ab7761e1" /* webpackChunkName: "locale_he_46json_ab7761e1" */),
      cache: true
    }
  ],
  hu: [
    {
      key: "locale_hu_46json_b52bee16",
      load: () => import("#nuxt-i18n/b52bee16" /* webpackChunkName: "locale_hu_46json_b52bee16" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_c29bff49",
      load: () => import("#nuxt-i18n/c29bff49" /* webpackChunkName: "locale_it_46json_c29bff49" */),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_46json_29936b87",
      load: () => import("#nuxt-i18n/29936b87" /* webpackChunkName: "locale_ja_46json_29936b87" */),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_a3a42d1f",
      load: () => import("#nuxt-i18n/a3a42d1f" /* webpackChunkName: "locale_ko_46json_a3a42d1f" */),
      cache: true
    }
  ],
  ku: [
    {
      key: "locale_ku_46json_78427efc",
      load: () => import("#nuxt-i18n/78427efc" /* webpackChunkName: "locale_ku_46json_78427efc" */),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_306b675f",
      load: () => import("#nuxt-i18n/306b675f" /* webpackChunkName: "locale_nl_46json_306b675f" */),
      cache: true
    }
  ],
  no: [
    {
      key: "locale_no_46json_c3786e9c",
      load: () => import("#nuxt-i18n/c3786e9c" /* webpackChunkName: "locale_no_46json_c3786e9c" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_a780a1a6",
      load: () => import("#nuxt-i18n/a780a1a6" /* webpackChunkName: "locale_pl_46json_a780a1a6" */),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_12c0ad77",
      load: () => import("#nuxt-i18n/12c0ad77" /* webpackChunkName: "locale_pt_46json_12c0ad77" */),
      cache: true
    }
  ],
  ro: [
    {
      key: "locale_ro_46json_2beaea91",
      load: () => import("#nuxt-i18n/2beaea91" /* webpackChunkName: "locale_ro_46json_2beaea91" */),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_46json_c0c00eb9",
      load: () => import("#nuxt-i18n/c0c00eb9" /* webpackChunkName: "locale_ru_46json_c0c00eb9" */),
      cache: true
    }
  ],
  srcyrl: [
    {
      key: "locale_sr_46json_999cb6c6",
      load: () => import("#nuxt-i18n/999cb6c6" /* webpackChunkName: "locale_sr_46json_999cb6c6" */),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_f59754ac",
      load: () => import("#nuxt-i18n/f59754ac" /* webpackChunkName: "locale_sv_46json_f59754ac" */),
      cache: true
    }
  ],
  tr: [
    {
      key: "locale_tr_46json_6cd13007",
      load: () => import("#nuxt-i18n/6cd13007" /* webpackChunkName: "locale_tr_46json_6cd13007" */),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_45db5f7a",
      load: () => import("#nuxt-i18n/45db5f7a" /* webpackChunkName: "locale_uk_46json_45db5f7a" */),
      cache: true
    }
  ],
  zhS: [
    {
      key: "locale_zh_hans_46json_9dd78bef",
      load: () => import("#nuxt-i18n/9dd78bef" /* webpackChunkName: "locale_zh_hans_46json_9dd78bef" */),
      cache: true
    }
  ],
  zhT: [
    {
      key: "locale_zh_hant_46json_ca2f8436",
      load: () => import("#nuxt-i18n/ca2f8436" /* webpackChunkName: "locale_zh_hant_46json_ca2f8436" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/3a07140e" /* webpackChunkName: "config_i18n_46config_46ts_3a07140e" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: true,
    fullInstall: true,
    dropMessageCompiler: true,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "af",
      name: "Afrikaans",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/af.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ar",
      name: "Arabic",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/ar.json",
          cache: undefined
        }
      ]
    },
    {
      code: "bg",
      name: "Bulgarian (Български)",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/bg.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ca",
      name: "Catalan",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/ca.json",
          cache: undefined
        }
      ]
    },
    {
      code: "cs",
      name: "Czech",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/cs.json",
          cache: undefined
        }
      ]
    },
    {
      code: "da",
      name: "Danish",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/da.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      name: "Deutsch",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "dum",
      name: "In-Context Editor",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/dum.json",
          cache: undefined
        }
      ]
    },
    {
      code: "el",
      name: "Greek",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/el.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      name: "English",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      name: "Español",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fi",
      name: "Finnish",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/fi.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      name: "Français",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/fr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "he",
      name: "Hebrew",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/he.json",
          cache: undefined
        }
      ]
    },
    {
      code: "hu",
      name: "Hungarian",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/hu.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      name: "Italiano",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/it.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ja",
      name: "Japanese",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/ja.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ko",
      name: "Korean",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/ko.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ku",
      name: "Kurdish",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/ku.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      name: "Nederlands",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/nl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "no",
      name: "Norsk",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/no.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pl",
      name: "Polish",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/pl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt",
      name: "Portugese",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/pt.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ro",
      name: "Romanian",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/ro.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ru",
      name: "Russian",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/ru.json",
          cache: undefined
        }
      ]
    },
    {
      code: "srcyrl",
      name: "Serbian",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/sr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sv",
      name: "Swedish",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/sv.json",
          cache: undefined
        }
      ]
    },
    {
      code: "tr",
      name: "Türkçe",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/tr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "uk",
      name: "Ukrainian",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/uk.json",
          cache: undefined
        }
      ]
    },
    {
      code: "zhS",
      name: "Simplified Chinese",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/zh_hans.json",
          cache: undefined
        }
      ]
    },
    {
      code: "zhT",
      name: "Traditional Chinese",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/zh_hant.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "../src/i18n/locales/processed",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "af",
    name: "Afrikaans",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/af.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ar",
    name: "Arabic",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/ar.json",
        cache: undefined
      }
    ]
  },
  {
    code: "bg",
    name: "Bulgarian (Български)",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/bg.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ca",
    name: "Catalan",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/ca.json",
        cache: undefined
      }
    ]
  },
  {
    code: "cs",
    name: "Czech",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/cs.json",
        cache: undefined
      }
    ]
  },
  {
    code: "da",
    name: "Danish",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/da.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    name: "Deutsch",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "dum",
    name: "In-Context Editor",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/dum.json",
        cache: undefined
      }
    ]
  },
  {
    code: "el",
    name: "Greek",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/el.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    name: "English",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    name: "Español",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fi",
    name: "Finnish",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/fi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "Français",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "he",
    name: "Hebrew",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/he.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hu",
    name: "Hungarian",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/hu.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    name: "Italiano",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/it.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ja",
    name: "Japanese",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/ja.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ko",
    name: "Korean",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/ko.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ku",
    name: "Kurdish",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/ku.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    name: "Nederlands",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/nl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "no",
    name: "Norsk",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/no.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pl",
    name: "Polish",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/pl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    name: "Portugese",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/pt.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ro",
    name: "Romanian",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/ro.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ru",
    name: "Russian",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/ru.json",
        cache: undefined
      }
    ]
  },
  {
    code: "srcyrl",
    name: "Serbian",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/sr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sv",
    name: "Swedish",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/sv.json",
        cache: undefined
      }
    ]
  },
  {
    code: "tr",
    name: "Türkçe",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/tr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "uk",
    name: "Ukrainian",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/uk.json",
        cache: undefined
      }
    ]
  },
  {
    code: "zhS",
    name: "Simplified Chinese",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/zh_hans.json",
        cache: undefined
      }
    ]
  },
  {
    code: "zhT",
    name: "Traditional Chinese",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/src/i18n/locales/processed/zh_hant.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/